namespace TabAurous.OMS {
    export interface HSNForm {
        Code: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        TaxCode: Serenity.LookupEditor;
        Description: Serenity.StringEditor;
    }

    export class HSNForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.HSN';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HSNForm.init)  {
                HSNForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(HSNForm, [
                    'Code', w0,
                    'Name', w0,
                    'TaxCode', w1,
                    'Description', w0
                ]);
            }
        }
    }
}
